import React from "react";
import classNames from "classnames";

type AvatarProps = ({
    avatar: string;
    background?: string;
    name?: string;
    label?: string;
} | {
    avatar?: string;
    background: string;
    name: string;
    label?: string;
}) & {
    className?: string;
    onClick?: (...args: any[]) => any
}
export default function UserAvatar({
    avatar,
    background,
    name,
    label,
    ...props // Compatible with Dropdown Trigger
}: AvatarProps) {
    // https://github.com/react-component/trigger/blob/master/src/index.tsx#L858
    const className = classNames('icon-btn wrap_name', props.className || '');
    return (
        // https://github.com/react-component/trigger/blob/master/src/index.tsx#L806
        <i {...props} className={className} tabIndex={0} role="button" aria-controls="user-dropdown-menu">
            {
                avatar ?
                    <img src={avatar} alt={label} /> :
                    <p style={{ background }} aria-label={label}>{name[0] && name[0].toUpperCase()}</p>
            }
        </i>
    )
}
